import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type ReportAccessGrant } from '@webapp/platform/iam/entities/ReportAccessGrant'
import messages from './messages'
import { useMutateRevokeReportAccessGrant } from '../../models/useMutateRevokeReportAccessGrant'

export const useRevokeReportAccessGrantPresenter = () => {
  const intl = useProcurifyIntl()
  const { revokeReportAccessGrant, isRevoking } =
    useMutateRevokeReportAccessGrant()

  /**
   * Optimistically removes the tag then DELETEs the grant — no confirmation
   * (BHV-017). On error the Model restores the grant to the top of the list
   * (BHV-018); this hook shows the error toast and rejects.
   */
  const revoke = async (
    grant: ReportAccessGrant,
    secondaryCategoryId: number
  ): Promise<void> => {
    try {
      await revokeReportAccessGrant({ grant, secondaryCategoryId })
    } catch (err) {
      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.errorToastDefaultMessage),
      })

      throw err
    }
  }

  return {
    commands: {
      revoke,
    },
    states: {
      isRevoking,
    },
  }
}
